<h2><fa-icon icon="users"></fa-icon> Tenants</h2>
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  [filterable]="true"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [navigable]="true"
  [loading]="loading"
  [columnMenu]="true"
  [resizable]="true"
>
  <ng-template kendoGridToolbarTemplate>
    <button class="btn btn-primary" kendoGridAddCommand>
      <!-- New Tenant -->
      <fa-icon icon="plus"></fa-icon>
    </button>
  </ng-template>
  <kendo-grid-column
    field="Id"
    title="ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>

  <kendo-grid-column field="Code" title="Code">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-isNew="isNew">
      <input #input class="k-textbox" [formControl]="formGroup.get('Code')">
      <kendo-popup
        [anchor]="input"
        *ngIf="formGroup.get('Code').invalid && !(isNew && formGroup.get('Code').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
        <div class="tooltip-stacked">
          <div *ngIf="formGroup.get('Code').hasError('required')">
            <span class="k-icon k-i-warning"></span>
            Code is required
           </div>
           <div *ngIf="formGroup.get('Code').hasError('minlength')">
            <span class="k-icon k-i-warning"></span>
            Code must be at least 3 characters
           </div>         
           <div *ngIf="formGroup.get('Code').hasError('maxlength')">
            <span class="k-icon k-i-warning"></span>
            Code must not exceed 25 characters
           </div>
           <div *ngIf="formGroup.get('Code').hasError('pattern')">
            <span class="k-icon k-i-warning"></span>
            Code must only contain letters, numbers, underscores, dashes, periods
           </div> 
           <div *ngIf="formGroup.get('Code').hasError('unique')">
            <span class="k-icon k-i-warning"></span>
            Code is already taken by another tenant
           </div> 
        </div>         
      </kendo-popup>
    </ng-template>     
  </kendo-grid-column>

  <kendo-grid-column field="Name" title="Name">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-isNew="isNew">
      <input #input class="k-textbox" [formControl]="formGroup.get('Name')">
      <kendo-popup
        [anchor]="input"
        *ngIf="formGroup.get('Name').invalid && !(isNew && formGroup.get('Name').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
       <div class="tooltip-stacked">
        <div *ngIf="formGroup.get('Name').hasError('required')">
          <span class="k-icon k-i-warning"></span>
          Name is required
         </div>
         <div *ngIf="formGroup.get('Name').hasError('minlength')">
          <span class="k-icon k-i-warning"></span>
          Name must be at least 3 characters
         </div>
         <div *ngIf="formGroup.get('Name').hasError('maxlength')">
          <span class="k-icon k-i-warning"></span>
          Name must not exceed 50 characters
         </div>
         <div *ngIf="formGroup.get('Name').hasError('pattern')">
          <span class="k-icon k-i-warning"></span>
          Name must only contain letters, numbers, spaces, colons, underscores, dashes, periods
         </div> 
       </div>
      </kendo-popup>
    </ng-template>     
  </kendo-grid-column>

  <kendo-grid-column field="Description" title="Description">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-isNew="isNew">
      <input #input class="k-textbox" [formControl]="formGroup.get('Description')">
      <kendo-popup
        [anchor]="input"
        *ngIf="formGroup.get('Description').invalid && !(isNew && formGroup.get('Description').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
       <div class="tooltip-stacked">
        <div *ngIf="formGroup.get('Description').hasError('maxlength')">
          <span class="k-icon k-i-warning"></span>
          Description must not exceed 200 characters
         </div>
         <div *ngIf="formGroup.get('Description').hasError('pattern')">
          <span class="k-icon k-i-warning"></span>
          Description must only contain letters, numbers, spaces, colons, semicolons, underscores, dashes, periods
         </div> 
       </div>
      </kendo-popup>
    </ng-template>     
  </kendo-grid-column>

  <kendo-grid-command-column title="" width="120">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button class="btn btn-primary" kendoGridEditCommand>
        <fa-icon icon="pen"></fa-icon>
      </button>
      <button class="btn btn-danger" kendoGridRemoveCommand>
        <fa-icon icon="trash"></fa-icon>
      </button>
      <button
        class="btn btn-primary"
        kendoGridSaveCommand
        [disabled]="formGroup?.invalid"
      >
        <fa-icon icon="check"></fa-icon>
      </button>
      <button class="btn btn-secondary" kendoGridCancelCommand>
        <fa-icon icon="times"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
  <div *kendoGridDetailTemplate="let dataItem">
    <app-tenant [tenant]="dataItem"></app-tenant>
  </div>
</kendo-grid>
